@if(!isCalendlyIntegrated && !isLoading)
{
<app-integrate-calenderly></app-integrate-calenderly>
}
@else if(isCalendlyIntegrated && !isLoading){
<div class="w-full px-4">
  <!--No data found-->
  <!-- <div class="w-full flex flex-column align-items-center py-4 gap-5">
      <div class="w-full flex align-items-center justify-content-center">
        <img src="../../../assets/icons/nodatafound.svg" alt="" class="w-full max-w-16rem">
      </div>
        <b class="text-center font-normal text-2xl" style="color: #000086;">No Data Found !</b>
    </div> -->

  <div class="w-full flex flex-column gap-3">
    <h1 class="text-left text-3xl font-medium">Mentors</h1>
    <div class="w-full flex flex-column gap-4">
      <app-mentors-search-filter (onSearch)="handleSearchOutput($event)"
        [isSearching]="isSearching" [isOperations]="isOperations"></app-mentors-search-filter>
      <div class="w-full flex flex-column gap-2">
        <h2 class="text-left text-xl font-medium">Mentor List</h2>
        <p-table *ngIf="mentors && mentors.length > 0; else noRecordsFound" [value]="mentors" [lazyLoadOnInit]="false"
          [alwaysShowPaginator]="true" [showCurrentPageReport]="true" [paginator]="mentors.length!=total"
          [rows]="rowSize" [loading]="isSearching" [totalRecords]="total" [first]="first" [lazy]="true"
          (onLazyLoad)="onLazyLoad($event)" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 20, 30]"
          [showPageLinks]="true" styleClass="p-datatable-gridlines tableCon" [tableStyle]="{ 'min-width': '50rem' }">
          <ng-template pTemplate="header">
            <tr>
              <th>Mentor Name</th>
              <th>Email Address</th>
              <th>Experience</th>
              <th>No. of Students</th>
              <th>Company/Institute</th>
              <th *ngIf="!isOperations">View Resume</th>
              <th>Actions</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-mentor let-i="rowIndex">
            <tr>
              <td>{{mentor.name}}</td>
              <td>{{mentor.email}}</td>
              <td>{{mentor.totalExperience}} years</td>
              <td>{{mentor.totalStudents}}</td>
              <td>{{mentor.companyOrSchool}}</td>
              <td *ngIf="!isOperations">
                <p-button *ngIf="mentor.resumeUrl && mentor.resumeUrl!=''" label="View Resume" icon="pi pi-file"
                  styleClass="resume" (onClick)="openResume(mentor.resumeUrl)" />
              </td>
              <td>
                <div class="w-auto inline-flex align-items-center gap-2">
                  <p-button [disabled]="mentor.state !== 1" label="Login" icon="pi pi-sign-in"
                    (onClick)="loginAsMentor(mentor.id)" styleClass="login" />
                  <p-button *ngIf="mentor.state==0 || mentor.state==2" [loading]="isAccepting" label="Accept"
                    icon="pi pi-check" styleClass="accept" (onClick)="acceptMentorRequest(mentor.id,i)" />
                  <p-button *ngIf="!isOperations && (mentor.state==0 || mentor.state==1)" [loading]="isRejecting" label="Reject"
                    icon="pi pi-times" styleClass="reject" (onClick)="rejectMentorRequest(mentor.id,i)" />
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <ng-template #noRecordsFound>
          <div class="w-full flex flex-column align-items-center py-4 gap-5">
            <div class="w-full flex align-items-center justify-content-center">
              <img src="../../../assets/icons/nodatafound.svg" alt="" class="w-full max-w-16rem">
            </div>
            <b class="text-center font-normal text-2xl" style="color: #000086;">No Data Found !</b>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<div class="card flex justify-content-center">
  <p-toast />
  <p-dialog [(visible)]="isVisible" [modal]="true" [responsive]="true" [baseZIndex]="10">
    <div class="flex flex-column align-items-center p-5 surface-overlay border-round">
      <div class="border-circle bg-primary inline-flex justify-content-center align-items-center h-6rem w-6rem">
        <img src="../../../assets/images/calenderly-icon.png" alt="" class="w-full h-full block">
      </div>
      <span class="font-bold text-xl block mb-2 mt-4">
        Calenderly not Integrated !
      </span>
      <p class="mb-0">The mentor has not accepted the Calendly invitation yet. Please resend the invitation from
        calendly.'</p>
      <div class="flex align-items-center gap-2 mt-4">
        <!-- <button pButton label="Resend" [loading]="isResendingInvite" (click)="resendInvite()" class="w-8rem accepts">
        </button> -->
        <button pButton label="Ok" (click)="cancel()" class="p-button-outlined w-8rem rejects">
        </button>
      </div>
    </div>
  </p-dialog>
</div>
}
@else {
<div *ngIf="isLoading" class="flex gap-4 align-items-center justify-content-center py-5">
  <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4" fill="var(--surface-ground)" animationDuration=".5s" />
</div>
}